/**
 * Cognito-compatible password rules (AWS default policy).
 * Use these to show users what format is required.
 */
export const PASSWORD_RULES = [
  'At least 8 characters',
  'At least one uppercase letter',
  'At least one lowercase letter',
  'At least one number',
  'At least one special character (e.g. !@#$%^&*)',
];

/**
 * Mobile number format hint for forms.
 */
export const MOBILE_FORMAT_HINT = 'e.g. +1234567890 (10–15 digits, with or without country code)';

/**
 * Validates password against Cognito-style rules.
 * @param {string} password
 * @returns {{ valid: boolean, failedRules: string[] }}
 */
export function validatePassword(password) {
  const failed = [];
  if (!password || password.length < 8) failed.push(PASSWORD_RULES[0]);
  if (!/[A-Z]/.test(password)) failed.push(PASSWORD_RULES[1]);
  if (!/[a-z]/.test(password)) failed.push(PASSWORD_RULES[2]);
  if (!/\d/.test(password)) failed.push(PASSWORD_RULES[3]);
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) failed.push(PASSWORD_RULES[4]);
  return { valid: failed.length === 0, failedRules: failed };
}

/**
 * Normalizes mobile to digits only for validation; allows optional leading +.
 * @param {string} value
 * @returns {string}
 */
export function normalizeMobile(value) {
  if (!value || typeof value !== 'string') return '';
  return value.replace(/\D/g, '');
}

/**
 * Validates mobile number (10–15 digits after stripping non-digits).
 * @param {string} value
 * @returns {boolean}
 */
export function validateMobile(value) {
  const digits = normalizeMobile(value);
  return digits.length >= 10 && digits.length <= 15;
}
